<template>
  <v-app>
    <LoadingWidget v-if="loading" />
    <template v-else>
      <HeaderShell />

      <v-main>
        <router-view v-bind="$route.meta" />

        <FooterSheel />
      </v-main>
    </template>

    <FloatButtonsWidget />

    <shopping-cart-widget />
  </v-app>
</template>

<script>
import FooterSheel from "./components/shell/FooterShell.vue";
import HeaderShell from "./components/shell/HeaderShell.vue";
import LoadingWidget from "./components/widgets/LoadingWidget.vue";
import FloatButtonsWidget from "./components/widgets/FloatButtonsWidget.vue";

export default {
  data: () => ({
    loading: true,
    dialog: false,
  }),
  created() {
    this.updateDocumentTitle();
  },
  mounted() {
    const config = this.$rest("config").get({
      save: (state, data) => (state.item = data),
    });

    const informations = this.$rest("informations").get({
      save: (state, data) => (state.item = data),
    });
    const categories = this.$rest("categories").get();
    const products = this.$rest("products").get();

    Promise.all([config, informations, categories, products]).then(
      () => (this.loading = false)
    );
  },
  computed: {
    config() {
      return this.$rest("config").item;
    },
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
    config(v) {
      if (v.primary_color)
        this.$vuetify.theme.themes.light.primary = v.primary_color.substring(
          0,
          7
        );

      if (v.secondary_color)
        this.$vuetify.theme.themes.light.secondary =
          v.secondary_color.substring(0, 7);

      if (v.header_color)
        this.$vuetify.theme.themes.light.accent = v.header_color.substring(
          0,
          7
        );
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = this.name ? this.name : "";
    },
  },
  components: {
    LoadingWidget,
    HeaderShell,
    FooterSheel,
    FloatButtonsWidget,
  },
};
</script>
